import { render, staticRenderFns } from "./content-panel.vue?vue&type=template&id=78571772&scoped=true&"
import script from "./content-panel.vue?vue&type=script&lang=js&"
export * from "./content-panel.vue?vue&type=script&lang=js&"
import style0 from "./content-panel.vue?vue&type=style&index=0&id=78571772&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78571772",
  null
  
)

export default component.exports